import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Directive({
    selector: '[appPreventDoubleClick]',
    standalone: true
})
export class PreventDoubleClickDirective {
    @Output() throttledClick = new EventEmitter();

    private clicks = new Subject();
    private subscription = new Subscription();
    private throttleTime = 500;
    
    ngOnInit() {
        this.subscription = this.clicks.pipe(
            throttleTime(this.throttleTime)
        ).subscribe(e => this.emitThrottledClick(e));
    }
    
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    emitThrottledClick(e: any) {
        this.throttledClick.emit(e);
    }

    @HostListener('click', ['$event'])
    clickEvent(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        this.clicks.next(event);
    }
}